import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

export const videoFields = [
  {
    name: 'videoSrc',
    type: 'string',
    helperText:
      'The URL of the video source. This can be a direct link to a video file or a platform like YouTube or Vimeo.',
  },
  {
    name: 'hasGradientTransition',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Enable or disable the gradient transition effect for the video section.',
  },
  {
    name: 'darkMode',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Enable or disable dark mode for the video section. This will apply a dark background and text color.',
  },
  imageField('thumbnail'),
] as const satisfies DeepReadonly<Input[]>;

const videoConfig = {
  name: 'Video',
  inputs: videoFields,
  override: true,
};

export type VideoConfigProps = GenerateBuilder<typeof videoFields>;

export default videoConfig;
